import { PersonSearchResult } from '../models/person.model';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class MainService {
    @Output() searchResultsPerson: EventEmitter<PersonSearchResult[]> = new EventEmitter();
    @Output() profileResultsPerson: EventEmitter<PersonSearchResult> = new EventEmitter();

    searchResult: PersonSearchResult[] = [];
    profileResult: PersonSearchResult = new PersonSearchResult();



    constructor(private httpClient: HttpClient, private router: Router) { }

    searchPerson(person: string) {
        const splitted = person.split(' ');
        let surname = '';
        let name = '';

        if (splitted.length === 1) {
            surname = splitted[0];
        } else if (splitted.length === 2) {
            surname = splitted[1];
            name = splitted[0];
        } else if (splitted.length > 2) {
            surname = splitted[2];
            name = splitted[0] + ' ' + splitted[1];
        }

        this.httpClient.get<PersonSearchResult[]>(environment.backendUrl + '/person/personFind/' + surname + '/' + name).subscribe
            ((searchResult) => {
                this.searchResult = searchResult;
                this.searchResultsPerson.emit(this.searchResult);
                this.router.navigate(['/searchProfiles/' + person]);

            });
    }

    displayPerson(personId: string | undefined) {
        this.router.navigate(['tree/' + environment.currentTreeUrl + '/profile/view/' + personId]);
    }

    editPerson(personId: string) {
        this.router.navigate(['tree/' + environment.currentTreeUrl + '/profile/edit/' + personId]);
    }

}
